export const subscriptionsTranslation = {
  en: {
    Subscriptions: "Subscriptions",
    Features: "Features",
    "Manage Features": "Manage Features",
    "Payment Types": "Payment Types",
    "Manage Payment Types": "Manage Payment Types",
    "Add Payment Type": "Add Payment Type",
    "Edit Payment Type": "Edit Payment Type",
    "Add New Payment Type": "Add New Payment Type",
    "Update Payment Type": "Update Payment Type",
    "Add Payment Type Button": "Add Payment Type",
    "Delete Payment Type Confirmation": "Are you sure you want to delete this payment type",
    "Search Payment Types": "Search Payment Types",
    "Title (EN)": "Title (EN)",
    "Title (AR)": "Title (AR)",
    Title: "Title",
    Icon: "Icon",
    Clear: "Clear",
    "There are no records to display": "There are no records to display",
    "Drag & Drop or Click to Upload": "Drag & Drop or Click to Upload",
    "Supported formats: JPG, PNG": "Supported formats: JPG, PNG",
    "Manage Plans": "Manage Plans",
    "Add Feature": "Add Feature",
    "Feature Name": "Feature Name",
    Active: "Active",
    Inactive: "Inactive",
    Home: "Home",
    "Manage subscriptions": "Manage subscriptions",
    invoices: "Invoices",
    viewManageInvoices: "View and manage invoices",
    payments: "Payments",
    viewManagePayments: "View and manage payments",
    Coupons: "Coupons",
    "Manage Coupons": "Manage Coupons",
    "User Name": "User Name",
    Plan: "Plan",
    "Start Date": "Start Date",
    "End Date": "End Date",
    Status: "Status",
    Action: "Action",
    "Search Subscription": "Search Subscription",
    "Add Subscription": "Add Subscription",
    "Edit Subscription": "Edit Subscription",
    "Add New Subscription": "Add New Subscription",
    "Update Subscription": "Update Subscription",
    "Select User": "Select User",
    "pleaseSelectUserForSubscription":
      "Please select a user to make a subscription",
    "Select Plan": "Select Plan",
    cancelSubscriptionConfirmation: "Cancel subscription confirmation",
    Cancel: "Cancel",
    "Confirm Cancel": "Confirm Cancel",
    cancelActionWarning: "This action cannot be undone.",
    "Invoice Number": "Invoice Number",
    "Issue Date": "Issue Date",
    "Due Date": "Due Date",
    Download: "Download",
    Actions: "Actions",
    searchInvoice: "Search Invoice",
    addInvoice: "Add Invoice",
    editInvoice: "Edit Invoice",
    addNewInvoice: "Add New Invoice",
    updateInvoice: "Update Invoice",
    addInvoiceButton: "Add Invoice",
    "Select Payment": "Select Payment",
    "No payments available for this user": "No payments available for this user",
    "Total Amount": "Total Amount",
    "Upload Invoice": "Upload Invoice",
    Paid: "Paid",
    Unpaid: "Unpaid",
    deleteInvoiceConfirmation: "Delete invoice confirmation",
    Delete: "Delete",
    deleteActionWarning: "This action cannot be undone.",
    Amount: "Amount",
    "Payment Method": "Payment Method",
    "Created At": "Created At",
    Transaction: "Transaction",
    Pending: "Pending",
    Completed: "Completed",
    Declined: "Declined",
    searchPayment: "Search Payment",
    addPayment: "Add Payment",
    editPayment: "Edit Payment",
    addNewPayment: "Add New Payment",
    updatePayment: "Update Payment",
    addPaymentButton: "Add Payment",
    deletePaymentConfirmation: "Delete payment confirmation",
    "Coupon Code": "Coupon Code",
    Percentage: "Percentage",
    "Usage Counter": "Usage Counter",
    "Subscription Type": "Subscription Type",
    "Commercial No.": "Commercial No.",
    "Expiry Date": "Expiry Date",
    "Search Coupon": "Search Coupon",
    "Add Coupon": "Add Coupon",
    "Edit Coupon": "Edit Coupon",
    "Add New Coupon": "Add New Coupon",
    "Update Coupon": "Update Coupon",
    "User Type": "User Type",
    All: "All",
    New: "New",
    Existing: "Existing",
    deleteCouponConfirmation: "Delete coupon confirmation",
    "All Subscriptions": "All Subscriptions",
    "Basic Subscriptions": "Basic Subscriptions",
    "Professional Subscriptions": "Professional Subscriptions",
    "Enhanced Subscriptions": "Enhanced Subscriptions",
    "Subscription canceled successfully!": "Subscription canceled successfully!",
    "Failed to cancel subscription.": "Failed to cancel subscription.",
    "Subscription updated successfully!": "Subscription updated successfully!",
    "Subscription added successfully!": "Subscription added successfully!",
    "Failed to update subscription.": "Failed to update subscription.",
    "Failed to add subscription.": "Failed to add subscription.",
    Expired: "Expired",
    Cancelled: "Cancelled",
    Paused: "Paused",
    Trial: "Trial",
    "Select": "Select an option....",
    "Choose date range for subscription": "Choose date range for subscription",
    "Choose date range for payments": "Choose date range for payments",
    "Choose date range for coupons": "Choose date range for coupons",
    "Choose date range for invoices": "Choose date range for invoices",
    "Enter invoice number": "Enter invoice number",
    Cycle: "Cycle",
    "Cycle field info": "Cycle field information",
    "Cycle field help":
      "A manual sequence number for this subscription's billing period (e.g. 1 = initial term, 2 = first renewal). This is for record-keeping only — it is not calculated automatically and will be shown to the customer on their account page, so update it manually each renewal if you want it to stay accurate.",
    "Event Log": "Event Log",
    "Audit Log": "Audit Log",
    "Time": "Time",
    "Verification Method": "Verification Method",
    "IP Address": "IP Address",
    "Total Signatures": "Total Signatures",
    "Total Signatures Used": "Total Signatures Used",
  },
  ar: {
    Features: "الميزات",
    "Manage Features": "إدارة الميزات",
    "Payment Types": "أنواع الدفع",
    "Manage Payment Types": "إدارة أنواع الدفع",
    "Add Payment Type": "إضافة نوع دفع",
    "Edit Payment Type": "تعديل نوع الدفع",
    "Add New Payment Type": "إضافة نوع دفع جديد",
    "Update Payment Type": "تحديث نوع الدفع",
    "Add Payment Type Button": "إضافة نوع دفع",
    "Delete Payment Type Confirmation": "هل أنت متأكد أنك تريد حذف نوع الدفع",
    "Search Payment Types": "البحث في أنواع الدفع",
    "Title (EN)": "العنوان (EN)",
    "Title (AR)": "العنوان (AR)",
    Title: "العنوان",
    Icon: "الأيقونة",
    "Drag & Drop or Click to Upload": "اسحب وأفلت أو انقر للتحميل",
    "Supported formats: JPG, PNG": "الصيغ المدعومة: JPG, PNG",
    "Manage Plans": "إدارة الخطط",
    search: "البحث في الاشتراكات",
    "Download PDF": "تحميل PDF",
    "Download Excel": "تحميل Excel",
    "Choose date range for report": "اختر نطاق التاريخ للاشتراك",
    "Clear": "مسح",
    "There are no records to display": "لا توجد سجلات للعرض",
    "Select Billing Cycle": "اختر دورة الفوترة",
    "Monthly": "شهري",
    "Yearly": "سنوي",
    "Subscriptions": "الاشتراكات",
    "Billing Cycle": "دورة الفوترة",
    "Edit": "تعديل",
    "View Page Not Found Image": "عرض صورة صفحة غير موجودة",
    "View Workflow Theme Logo": "عرض شعار سمة سير العمل",
    "View Logo Watermark": "عرض علامة الشعار المائية",
    "View Maintenance Image (EN)": "عرض صورة الصيانة (EN)",
    "View Maintenance Image (AR)": "عرض صورة الصيانة (AR)",
    "Add Feature": "إضافة ميزة",
    "Feature Name": "اسم الميزة",
    Active: "نشط",
    Inactive: "غير نشط",
    Home: "الرئيسية",
    "Manage subscriptions": "إدارة الاشتراكات",
    invoices: "الفواتير",
    viewManageInvoices: "عرض وإدارة الفواتير",
    payments: "المدفوعات",
    viewManagePayments: "عرض وإدارة المدفوعات",
    Coupons: "القسائم",
    "Manage Coupons": "إدارة القسائم",
    "User Name": "اسم المستخدم",
    Plan: "الخطة",
    "Start Date": "تاريخ البدء",
    "End Date": "تاريخ الانتهاء",
    Status: "الحالة",
    Action: "الإجراء",
    "Search Subscription": "البحث في الاشتراكات",
    "Add Subscription": "إضافة اشتراك",
    "Edit Subscription": "تعديل الاشتراك",
    "Add New Subscription": "إضافة اشتراك جديد",
    "Update Subscription": "تحديث الاشتراك",
    "Select User": "اختر المستخدم",
    "pleaseSelectUserForSubscription": "يرجى اختيار مستخدم لإنشاء الاشتراك",
    "Select Plan": "اختر الخطة",
    cancelSubscriptionConfirmation: "تأكيد إلغاء الاشتراك",
    Cancel: "إلغاء",
    "Confirm Cancel": "تأكيد الإلغاء",
    cancelActionWarning: "لا يمكن التراجع عن هذا الإجراء.",
    "Invoice Number": "رقم الفاتورة",
    "Issue Date": "تاريخ الإصدار",
    "Due Date": "تاريخ الاستحقاق",
    Download: "تحميل",
    Actions: "الإجراءات",
    searchInvoice: "البحث في الفواتير",
    addInvoice: "إضافة فاتورة",
    editInvoice: "تعديل الفاتورة",
    addNewInvoice: "إضافة فاتورة جديدة",
    updateInvoice: "تحديث الفاتورة",
    addInvoiceButton: "إضافة فاتورة",
    "Select Payment": "اختر الدفع",
    "No payments available for this user": "لا توجد مدفوعات متاحة لهذا المستخدم",
    "Total Amount": "المبلغ الإجمالي",
    "Upload Invoice": "تحميل الفاتورة",
    Paid: "مدفوع",
    Unpaid: "غير مدفوع",
    deleteInvoiceConfirmation: "تأكيد حذف الفاتورة",
    Delete: "حذف",
    deleteActionWarning: "لا يمكن التراجع عن هذا الإجراء.",
    Amount: "المبلغ",
    "Payment Method": "طريقة الدفع",
    "Created At": "تاريخ الإنشاء",
    Transaction: "المعاملة",
    Pending: "قيد الانتظار",
    Completed: "مكتمل",
    Declined: "مرفوض",
    searchPayment: "البحث في المدفوعات",
    addPayment: "إضافة دفعة",
    editPayment: "تعديل الدفعة",
    addNewPayment: "إضافة دفعة جديدة",
    updatePayment: "تحديث الدفعة",
    addPaymentButton: "إضافة دفعة",
    deletePaymentConfirmation: "تأكيد حذف الدفعة",
    "Coupon Code": "رمز القسيمة",
    Percentage: "النسبة المئوية",
    "Usage Counter": "عداد الاستخدام",
    "Subscription Type": "نوع الاشتراك",
    "Commercial No.": "الرقم التجاري",
    "Expiry Date": "تاريخ الانتهاء",
    "Search Coupon": "البحث في القسائم",
    "Add Coupon": "إضافة قسيمة",
    "Edit Coupon": "تعديل القسيمة",
    "Add New Coupon": "إضافة قسيمة جديدة",
    "Update Coupon": "تحديث القسيمة",
    "User Type": "نوع المستخدم",
    All: "الكل",
    New: "جديد",
    Existing: "موجود",
    deleteCouponConfirmation: "تأكيد حذف القسيمة",
    "All Subscriptions": "جميع الاشتراكات",
    "Basic Subscriptions": "الاشتراكات الأساسية",
    "Professional Subscriptions": "الاشتراكات المهنية",
    "Enhanced Subscriptions": "الاشتراكات المحسنة",
    "Subscription canceled successfully!": "تم إلغاء الاشتراك بنجاح!",
    "Failed to cancel subscription.": "فشل في إلغاء الاشتراك.",
    "Subscription updated successfully!": "تم تحديث الاشتراك بنجاح!",
    "Subscription added successfully!": "تم إضافة الاشتراك بنجاح!",
    "Failed to update subscription.": "فشل في تحديث الاشتراك.",
    "Failed to add subscription.": "فشل في إضافة الاشتراك.",
    Expired: "منتهي",
    Cancelled: "ملغى",
    Paused: "موقوف",
    Trial: "تجريبي",
    "Select": "اختر خيارًا....",
    "Choose date range for subscription": "اختر نطاق التاريخ للاشتراك",
    "Choose date range for payments": "اختر نطاق التاريخ للمدفوعات",
    "Choose date range for coupons": "اختر نطاق التاريخ للقسائم",
    "Choose date range for invoices": "اختر نطاق التاريخ للفواتير",
    "Enter invoice number": "أدخل رقم الفاتورة",
    Cycle: "الدورة",
    "Cycle field info": "معلومات حقل الدورة",
    "Cycle field help":
      "رقم تسلسلي يدوي لفترة الفوترة لهذا الاشتراك (مثال: 1 = المدة الأولية، 2 = أول تجديد). يُستخدم للتوثيق فقط — ولا يُحسب تلقائياً — وسيظهر للعميل في صفحة حسابه، لذا قم بتحديثه يدوياً عند كل تجديد إذا أردت أن يبقى دقيقاً.",
    "Event Log": "سجل الأحداث",
    "Audit Log": "سجل التدقيق",
    "Time": "الوقت",
    "Verification Method": "طريقة التحقق",
    "IP Address": "عنوان IP",
    "Total Signatures": "إجمالي التوقيعات",
    "Total Signatures Used": "إجمالي التوقيعات المستخدمة",
  },
};
